import {
  UpdatePathTemplateArgs,
  useGetPathTemplateQuery,
  useUpdatePathTemplateMutation,
} from '@/redux';
import { useNavigate } from 'react-router-dom';
import { notify } from '@/components';
import { FormPathTemplate } from './Form';
import { parseResponsiblePersonValue } from '../Tasks.Common';

interface Props {
  id: string;
  communityId?: string;
  onSaved?: () => any;
}

const useSubmit = (props: Props) => {
  const [update] = useUpdatePathTemplateMutation();

  return async (values: UpdatePathTemplateArgs) => {
    const updatedSteps = values.steps.map((step) => {
      const updatedTasks =
        step.groupedTaskData?.tasks.map((task) =>
          task.responsiblePerson
            ? {
                ...task,
                responsiblePerson: parseResponsiblePersonValue(
                  task.responsiblePerson as any as string,
                ),
              }
            : task,
        ) ?? [];

      return {
        ...step,
        groupedTaskData: step.groupedTaskData
          ? { ...step.groupedTaskData, tasks: updatedTasks }
          : null,
      };
    });

    const updatedValues: UpdatePathTemplateArgs = {
      ...values,
      steps: updatedSteps,
    };

    await update(updatedValues)
      .unwrap()
      .then(props.onSaved)
      .then(() => notify.success.t('pathTemplates.details.saved'));
  };
};

export function EditPathTemplatePanel(props: Props) {
  const submit = useSubmit(props);
  const { id, communityId } = props;
  const { currentData } = useGetPathTemplateQuery({ id });
  const push = useNavigate();

  return (
    <>
      {currentData && (
        <FormPathTemplate<UpdatePathTemplateArgs>
          onSubmit={submit}
          value={currentData}
          noTemplate
          onCancel={() => push(-1)}
          communityId={communityId}
        />
      )}
    </>
  );
}
